import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17dcd7fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "checkbox" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["for"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createElementVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.keep_me_logged_in) = $event)),
      id: $props.label + $setup.randomId
    }, null, 8, _hoisted_2), [
      [_vModelCheckbox, $setup.keep_me_logged_in]
    ]),
    _createElementVNode("label", {
      style: {"cursor":"pointer"},
      class: "d-flex align-center justify-center",
      for: $props.label + $setup.randomId
    }, [
      _hoisted_4,
      _createElementVNode("span", null, _toDisplayString($props.label), 1)
    ], 8, _hoisted_3)
  ]))
}